import React, { createContext, useContext, useState } from 'react';

const translations = {
  en: {
    dir: 'ltr',
    // Navbar
    shop: 'Shop',
    cart: 'Cart',
    // Home
    newCollection: '⚡ New Collection',
    heroTitle1: 'WEAR THE',
    heroTitle2: 'EDGE',
    heroSubtitle: 'Performance sportswear built for those who refuse to settle. Train hard. Look sharp.',
    shopNow: 'Shop Now',
    latestDrops: 'Latest',
    latestDrops2: 'Drops',
    premiumPieces: 'Premium pieces for peak performance',
    noProducts: 'No products available yet.',
    failedToLoad: 'Failed to load products',
    colors: 'colors',
    color: 'color',
    // ProductDetail
    back: '← Back',
    noImage: 'No image available',
    colorLabel: 'Color',
    sizeLabel: 'Size',
    quantityLabel: 'Quantity',
    addToCart: 'Add to Cart',
    addedToCart: '✓ Added to Cart!',
    selectSize: 'Please select a size',
    outOfStock: 'This color is out of stock',
    // Cart
    yourCart: 'Your',
    cartTitle2: 'Cart',
    cartEmpty: 'Your cart is empty',
    cartEmptyDesc: "Looks like you haven't added anything yet.",
    size: 'Size',
    subtotal: 'Subtotal',
    livraison: 'Delivery',
    calcAtCheckout: 'Calculated at checkout',
    total: 'Total',
    proceedToCheckout: 'Proceed to Checkout',
    continueShopping: 'Continue Shopping',
    // Checkout
    checkout: 'Checkout',
    personalInfo: 'Personal Information',
    fullName: 'Full Name',
    phoneNumber: 'Phone Number',
    deliveryInfo: 'Delivery Information',
    deliveryType: 'Delivery Type',
    homeDelivery: 'Home Delivery',
    homeDeliveryDesc: 'Delivered to your door',
    officePickup: 'Office Pickup',
    officePickupDesc: 'Pick up at delivery office',
    wilaya: 'Wilaya (State)',
    selectWilaya: '— Select your Wilaya —',
    commune: 'Commune',
    selectCommune: '— Select your Commune —',
    selectWilayaFirst: 'Select a wilaya first',
    fullAddress: 'Full Address',
    addressPlaceholder: 'Street name, building, apartment...',
    orderNotes: 'Order Notes (optional)',
    notesPlaceholder: 'Any special instructions...',
    orderSummary: 'Order Summary',
    placeOrder: '⚡ Place Order',
    placingOrder: 'Placing Order...',
    selectWilayaError: 'Please select your wilaya',
    selectCommuneError: 'Please select your commune',
    failedOrder: 'Failed to place order. Please try again.',
    // OrderSuccess
    orderPlaced: 'Order Placed!',
    thankYou: "Thank you for your order. We'll contact you shortly to confirm.",
    orderId: 'Order ID',
    callConfirm: 'Our team will call you to confirm delivery details',
    processed24h: 'Orders are processed within 24 hours',
  },
  fr: {
    dir: 'ltr',
    shop: 'Boutique',
    cart: 'Panier',
    newCollection: '⚡ Nouvelle Collection',
    heroTitle1: 'PORTEZ',
    heroTitle2: "L'EDGE",
    heroSubtitle: 'Vêtements de sport pour ceux qui refusent de se contenter. Entraînez-vous dur. Soyez impeccable.',
    shopNow: 'Acheter',
    latestDrops: 'Dernières',
    latestDrops2: 'Sorties',
    premiumPieces: 'Pièces premium pour des performances optimales',
    noProducts: 'Aucun produit disponible pour le moment.',
    failedToLoad: 'Échec du chargement des produits',
    colors: 'couleurs',
    color: 'couleur',
    back: '← Retour',
    noImage: 'Aucune image disponible',
    colorLabel: 'Couleur',
    sizeLabel: 'Taille',
    quantityLabel: 'Quantité',
    addToCart: 'Ajouter au panier',
    addedToCart: '✓ Ajouté au panier !',
    selectSize: 'Veuillez sélectionner une taille',
    outOfStock: 'Cette couleur est en rupture de stock',
    yourCart: 'Votre',
    cartTitle2: 'Panier',
    cartEmpty: 'Votre panier est vide',
    cartEmptyDesc: "Il semble que vous n'ayez rien ajouté encore.",
    size: 'Taille',
    subtotal: 'Sous-total',
    livraison: 'Livraison',
    calcAtCheckout: 'Calculée à la caisse',
    total: 'Total',
    proceedToCheckout: 'Passer à la caisse',
    continueShopping: 'Continuer les achats',
    checkout: 'Paiement',
    personalInfo: 'Informations personnelles',
    fullName: 'Nom complet',
    phoneNumber: 'Numéro de téléphone',
    deliveryInfo: 'Informations de livraison',
    deliveryType: 'Type de livraison',
    homeDelivery: 'Livraison à domicile',
    homeDeliveryDesc: 'Livré à votre porte',
    officePickup: 'Retrait en bureau',
    officePickupDesc: 'Récupérer au bureau de livraison',
    wilaya: 'Wilaya',
    selectWilaya: '— Sélectionnez votre Wilaya —',
    commune: 'Commune',
    selectCommune: '— Sélectionnez votre Commune —',
    selectWilayaFirst: 'Sélectionnez une wilaya d\'abord',
    fullAddress: 'Adresse complète',
    addressPlaceholder: 'Rue, bâtiment, appartement...',
    orderNotes: 'Notes de commande (optionnel)',
    notesPlaceholder: 'Instructions spéciales...',
    orderSummary: 'Résumé de commande',
    placeOrder: '⚡ Passer la commande',
    placingOrder: 'Commande en cours...',
    selectWilayaError: 'Veuillez sélectionner votre wilaya',
    selectCommuneError: 'Veuillez sélectionner votre commune',
    failedOrder: 'Échec de la commande. Veuillez réessayer.',
    orderPlaced: 'Commande passée !',
    thankYou: 'Merci pour votre commande. Nous vous contacterons bientôt pour confirmer.',
    orderId: 'N° de commande',
    callConfirm: 'Notre équipe vous appellera pour confirmer les détails de livraison',
    processed24h: 'Les commandes sont traitées dans les 24 heures',
  },
  ar: {
    dir: 'rtl',
    shop: 'المتجر',
    cart: 'السلة',
    newCollection: '⚡ مجموعة جديدة',
    heroTitle1: 'ارتدِ',
    heroTitle2: 'الحافة',
    heroSubtitle: 'ملابس رياضية للذين يرفضون التنازل. تدرّب بقوة. ابدُ أنيقاً.',
    shopNow: 'تسوّق الآن',
    latestDrops: 'أحدث',
    latestDrops2: 'الإصدارات',
    premiumPieces: 'قطع فاخرة لأداء متميز',
    noProducts: 'لا توجد منتجات متاحة حالياً.',
    failedToLoad: 'فشل تحميل المنتجات',
    colors: 'ألوان',
    color: 'لون',
    back: 'رجوع →',
    noImage: 'لا توجد صورة',
    colorLabel: 'اللون',
    sizeLabel: 'المقاس',
    quantityLabel: 'الكمية',
    addToCart: 'أضف إلى السلة',
    addedToCart: '✓ تمت الإضافة!',
    selectSize: 'الرجاء اختيار المقاس',
    outOfStock: 'هذا اللون غير متوفر',
    yourCart: 'سلة',
    cartTitle2: 'التسوق',
    cartEmpty: 'سلتك فارغة',
    cartEmptyDesc: 'يبدو أنك لم تضف أي شيء بعد.',
    size: 'المقاس',
    subtotal: 'المجموع الجزئي',
    livraison: 'التوصيل',
    calcAtCheckout: 'يحسب عند الدفع',
    total: 'الإجمالي',
    proceedToCheckout: 'المتابعة للدفع',
    continueShopping: 'مواصلة التسوق',
    checkout: 'إتمام الطلب',
    personalInfo: 'المعلومات الشخصية',
    fullName: 'الاسم الكامل',
    phoneNumber: 'رقم الهاتف',
    deliveryInfo: 'معلومات التوصيل',
    deliveryType: 'نوع التوصيل',
    homeDelivery: 'توصيل للمنزل',
    homeDeliveryDesc: 'يُوصّل إلى بابك',
    officePickup: 'استلام من المكتب',
    officePickupDesc: 'استلم من مكتب التوصيل',
    wilaya: 'الولاية',
    selectWilaya: '— اختر ولايتك —',
    commune: 'البلدية',
    selectCommune: '— اختر بلديتك —',
    selectWilayaFirst: 'اختر الولاية أولاً',
    fullAddress: 'العنوان الكامل',
    addressPlaceholder: 'اسم الشارع، المبنى، الشقة...',
    orderNotes: 'ملاحظات الطلب (اختياري)',
    notesPlaceholder: 'تعليمات خاصة...',
    orderSummary: 'ملخص الطلب',
    placeOrder: '⚡ تأكيد الطلب',
    placingOrder: 'جاري تأكيد الطلب...',
    selectWilayaError: 'الرجاء اختيار الولاية',
    selectCommuneError: 'الرجاء اختيار البلدية',
    failedOrder: 'فشل في تقديم الطلب. حاول مرة أخرى.',
    orderPlaced: 'تم تقديم الطلب!',
    thankYou: 'شكراً لطلبك. سنتصل بك قريباً للتأكيد.',
    orderId: 'رقم الطلب',
    callConfirm: 'سيتصل بك فريقنا لتأكيد تفاصيل التوصيل',
    processed24h: 'تتم معالجة الطلبات خلال 24 ساعة',
  },
};

const LangContext = createContext();

export function LangProvider({ children }) {
  const [lang, setLang] = useState('fr');
  const t = translations[lang];
  return (
    <LangContext.Provider value={{ lang, setLang, t, translations }}>
      <div dir={t.dir} style={{ fontFamily: lang === 'ar' ? "'Segoe UI', Tahoma, Arial, sans-serif" : undefined }}>
        {children}
      </div>
    </LangContext.Provider>
  );
}

export function useLang() {
  return useContext(LangContext);
}
